import { render, staticRenderFns } from "./noNotification.vue?vue&type=template&id=1f46e9c9"
import script from "./noNotification.vue?vue&type=script&lang=js"
export * from "./noNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports